import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CategoryService } from '../../../../service/category.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppdataService } from '../../../../service/appdata.service';
import { frontendserverurl } from '../../../../../environments/environment';

@Component({
  selector: 'app-category-create-edit',
  standalone: false,

  templateUrl: './category-create-edit.component.html',
  styleUrl: './category-create-edit.component.scss'
})
export class CategoryCreateEditComponent {
    readonly data = inject<any>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef<CategoryCreateEditComponent>);
    @Input() parentId = '';
    isNew = !this.data.category.name;
    categoryForm: any;
    imageList: any[] = [];
    frontendurl = frontendserverurl;
    tagList: any[] = [];
    groupedTags: any[] = [];
    statuses: any[] = [];

    @Output() onCloseClick = new EventEmitter<any>();

    constructor(
        private categoryService: CategoryService,
        private _fb: FormBuilder,
        private appdata: AppdataService
    ) {
        this.categoryForm = this._fb.group({
            name: [this.data.category?.name],
            description : [this.data.category?.description],
            image: [this.data.category?.image],
            tags: [this.data.category?.tags || []],
            status: [this.data.category.status],
        })
        this.appdata.categoryImagesThumbs.subscribe(data => this.imageList = data);
        this.tagList = appdata.tags;
        this.groupedTags = appdata.tagGroups.map(group => ({
            ...group,
            children: appdata.tags.filter(tag => tag.tagGroupId == group.id),
        })).filter(group => group.children.length > 0);
        this.statuses = appdata.statuses;
    }

    cancel(event: Event) {
        event.preventDefault();
        this.dialogRef.close();
    }

    getColorOfTag = (tag: any) => {
        return (this.appdata.tagGroups as any[]).find(group => group.id === tag.tagGroupId)?.colorClass;
    }
    
    clearImage(event: Event) {
        event.preventDefault();
        this.categoryForm.patchValue({ image: null });
    }
    selectImage(image: string) {
        this.categoryForm.patchValue({ image })
    }

    addTag(tag: any) {
        let tags = this.categoryForm.get('tags')?.value || [];
        if(!tags.some((t: any) => t.id === tag.id)) {
            tags.push(tag);
            this.categoryForm.patchValue({ tags })
        }
    }
    removeTag(tag: any) {
        let tags = this.categoryForm.get('tags')?.value || [];
        tags = tags.filter((t: any) => t.id !== tag.id);
        this.categoryForm.patchValue({ tags })
    }
    clearTags(event: Event) {
        event.preventDefault();
        this.categoryForm.patchValue({ tags: [] });
    }

    childrenAccessor = (node: any) => node.children ?? [];

    hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

    async onSubmit(){
        let addResult

        let category = this.categoryForm.value;

        if(this.data.category.parentId) {
            category.parentId = this.data.category.parentId; 
        }

        if(category.tags.length < 1) {
            category.tags = null;
        } else {
            category.tags = JSON.stringify(category.tags);
        }

        if(this.isNew == true) {
            addResult = await this.categoryService.createCategory(category);
        }

        if(this.isNew == false) {
            addResult = await this.categoryService.updateCategory(this.data.category.id, category);
        }

        if(addResult === false) {
            return;
        }

        this.dialogRef.close(addResult);
    }
}